import styled from "styled-components"
import { Header } from "../components/Header"
import { ErrorMessage } from "../components/ErrorMessage"
import { useCreateLogic } from "./create.logic"
import { useTranslation } from "../hooks/translation.hook"
import { Button } from "../components/Button"
import { InformationMessage } from "../components/InformationMessage"

const Input = styled.input`
    display: block;
    margin: 10px auto;
    width: 250px;
    font-size: 16px;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid black;
    padding: 7px;
`

export const CreatePage = () => {

    const { createPalletLocation, errorMessage, data, showData, setEansField, setLocationField } = useCreateLogic();
    const lang = useTranslation();

    return (
        <>
            <Header title={lang.createPalleteTitle} subtitle={"PALETE"} />
            <Input name='eans' onChange={(e) => setEansField(e.target.value)} placeholder="EANy np. 5950,5797,0875" />
            <Input name='location' onChange={(e) => setLocationField(e.target.value)} placeholder="Lokalizacja np. D-02-09-1/3" />
            <Button onClick={() => createPalletLocation()} text="Schowaj palete"/>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <InformationMessage>W pierwszym polu podaj EAN-y, w drugim lokalizację, podane EAN-y zostaną zapisane w podanej lokalizacji regału.</InformationMessage>
            {data && showData()}
        </>
    )
}